/** @jsxImportSource @emotion/react */
import React from "react";
import { ReactComponent as WalletIcon } from "../../../img/wallet_dark.svg";
import { Token } from "../../../store/global/TokenEnum";
import { Amount } from "../../../types/amount";
import clsx from "clsx";
import Skeleton from "react-loading-skeleton";
import { BalanceSection } from "./elements/BalanceSection";
import { fadeIn, verticalAlignedFlexbox } from "../../../config/commonCSS";

export interface BalanceDetailsProps {
  price: Amount;
  balanceToDisplay: string;
  amount: Amount;
  symbol: Token;
  onBalanceClick: () => void;
  shouldDisplayShimmer?: boolean;
  showBalance: boolean;
}

export const BalanceDetails: React.FC<BalanceDetailsProps> = ({
  symbol,
  amount,
  price,
  balanceToDisplay,
  onBalanceClick,
  shouldDisplayShimmer,
  showBalance,
}) => {
  const value = price.mul(amount).value;

  return (
    <BalanceSection>
      <div
        className={clsx({
          "d-flex": true,
          "justify-content-between": showBalance,
          "justify-content-end": !showBalance,
          "w-100": true,
        })}
      >
        {showBalance && (
          <div css={verticalAlignedFlexbox} style={{ cursor: "pointer" }}>
            <WalletIcon className="me-1" />
            <span
              css={fadeIn}
              data-sentry-mask="true"
              onClick={() => {
                onBalanceClick();
              }}
            >
              {balanceToDisplay} {symbol}
            </span>
          </div>
        )}
        {shouldDisplayShimmer ? (
          <Skeleton
            baseColor={"#4D5D5D"}
            highlightColor={"#33454566"}
            borderRadius={4}
            style={{ width: "50px" }}
          />
        ) : null}
        {!shouldDisplayShimmer && amount.value.gt(0) && value.gt(0) && (
          <span css={fadeIn}>
            =$
            {Intl.NumberFormat(navigator.language, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            }).format(value.toNumber())}
          </span>
        )}
      </div>
    </BalanceSection>
  );
};
